import React, { ReactElement } from 'react';
import { NextPageWithLayout } from 'next';
import StaticPageComponent from '@fuww/library/src/StaticPage';
import { useIntl } from 'react-intl';
import englishMarkdown from '../data/staticPages/code-of-ethics.md';
import frenchMarkdown from '../data/staticPages/code-of-ethics.fr.md';
import Layout from '../components/Layout';
import LinkAndAnchor from '../components/LinkAndAnchor';
import messages from '../lib/messages.json';
import Head from '../components/Head';
import HomeLink from '../components/HomeLink';
import Markdown from '../components/Markdown';
import { useSiteContext } from '../components/SiteContext';

const markdownByLanguage: Record<string, string> = {
  fr: frenchMarkdown,
};

const CodeOfEthicsPage: NextPageWithLayout = () => {
  const intl = useIntl();
  const { locale } = useSiteContext();
  const [language] = locale.split('-');
  const markdown = markdownByLanguage[language] ?? englishMarkdown;

  const breadcrumbs = [
    <HomeLink />,
    <LinkAndAnchor
      route="code-of-ethics"
      passHref
    >
      {intl.formatMessage(messages.codeOfEthics)}
    </LinkAndAnchor>,
  ];
  return (
    <>
      <Head
        title={intl.formatMessage(messages.codeOfEthics)}
        description={intl.formatMessage(messages.codeOfEthics)}
      />
      <StaticPageComponent
        breadcrumbs={breadcrumbs}
        content={<Markdown markdown={markdown} />}
        title={intl.formatMessage(messages.codeOfEthics)}
      />
    </>
  );
};

CodeOfEthicsPage.getLayout = (page: ReactElement) => (
  <Layout>
    {page}
  </Layout>
);

export default CodeOfEthicsPage;
